import React from "react";

const steps = [
    { n: "01", t: "Tell us about your home", d: "Book a free consultation and share your rooms and appliances." },
    { n: "02", t: "Get your smart home plan", d: "We recommend the right products and automation for your budget." },
    { n: "03", t: "Professional installation", d: "Our team retrofits your home in as little as an hour." },
    { n: "04", t: "Start living smart", d: "Control your home via switch, app, voice or automated scenes." },
];

export default function HowItWorks() {
    return (
        <section className="bg-[#0B1440] text-white py-24" data-testid="how-it-works">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="max-w-2xl">
                    <div className="text-xs tracking-[0.2em] uppercase text-[#1BB6F0] font-semibold">How it works</div>
                    <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
                        Smart home automation, made simple.
                    </h2>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {steps.map((s, i) => (
                        <div
                            key={i}
                            data-testid={`step-${i}`}
                            className="relative p-7 rounded-3xl bg-white/[0.04] border border-white/10 hover:border-[#1BB6F0]/60 transition-colors backdrop-blur-sm"
                        >
                            <div className="font-mono text-xs text-[#1BB6F0] tracking-widest">{s.n}</div>
                            <div className="mt-4 text-xl font-semibold">{s.t}</div>
                            <div className="mt-2 text-sm text-white/70 leading-relaxed">{s.d}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
